// extracted by mini-css-extract-plugin
export default {"wrapper":"zKlCtn7LXqFHZZ3GPC6T","title":"ZX5U1c3yHrXDUdHrVjd4","text":"maTrDkB5RulzCOTtv28d","date":"r38spA4c38B2MgCQYsNq"};